<div class="delivery-threshold-body">
    <div class="visual-frame">
        <div class="visual-overlay"></div>
        <div class="text-wrapper">
            <p class="onboarding-welcome text-center">
                {{ 'modals.after_complete_delivery_and_threshold_form.title' | translate: { name: userName } }}
            </p>
            <section class="text-card description-card">
                <p class="text-center">{{ 'modals.after_complete_delivery_and_threshold_form.description' | translate }}
                </p>
            </section>
            <div class="cta-row">
                <button mat-flat-button color="primary" (click)="onContinue()">
                    {{ 'modals.after_complete_delivery_and_threshold_form.button' | translate }}
                </button>
            </div>
        </div>

    </div>

</div>